<template>
	<div id="landing-contact" v-bind:style = "{backgroundImage: 'url(' + baseUrl + contactData[0].contactMapImage.url + ')' }">
		<div class="red-contact-container">
			<div class="contact-text-container light-text">
				<img class="vpd-logo" :src="baseUrl + contactData[0].companyLogoWhite.url"/>
				<div v-html="contactText"></div>
			</div>
		</div>
	</div>
</template>


<script>

import JsonProvider from '../../../services/DataService.js';
import {configData} from '../../../services/DataService.js';
import {MarkdownProvider} from '../../../services/DataService.js';

	export default {
		name: 'LandingContact',
		data: function() {
			return {
			contactText: "",
			contactData: [],
			baseUrl: "",
		}
	},
	
		created: async function() {
			var jsonGetter = new JsonProvider();
			this.contactData = await jsonGetter.fetchJsonObject('general-infos');
			var mdp = new MarkdownProvider();

			this.contactText = mdp.convertMarkdown(this.contactData[0].contactInfo);
			this.baseUrl = configData.baseUrl.data.baseUrl;
	}
}

</script>

<style scoped>
	#landing-contact{
		background-size: 100%;
		background-repeat: no-repeat;
		width: 100%;
		height: 80;
		padding-top: 66.64%; 
		z-index:0;
		position: relative;
	}

	.red-contact-container {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		width: 50%;
		background-color: rgba(170,28,72, 0.9);
		text-align: left;
	}

	.contact-text-container{
		display: inline-block;
		margin-top: 50%;
		color: white;
		margin-left: 15%;
		font-size: 1.7em;
	}

	.vpd-logo{
		width: 30%;
	}

	@media (min-width: 1200px) {
		#landing-contact{
			height: 80vh;
			padding-top: 0;
		}
		
		.contact-text-container{
			margin-top: 20%;
	}
		
	}

	@media (max-width: 767px) {
		.contact-text-container {
			font-size: 1em;
			margin-left: 1em;
			
		}
	}
	
	@media (max-width: 575px) {
		.contact-text-container {
			font-size: 0.8em;
            margin-top: 30%;
		}
	}
	

</style>

